import React, { Component } from 'react';
import { DatePicker, Select } from 'antd';
import { map } from 'lodash';
import moment from 'moment';
import Loader from '../../../Common/Component/Loader';
import {errorHandle} from "../../../Common/errorHandle";
import {formatToCurrency} from "../../../../Tools/formatToCurrency";

const { Option } = Select;

class MonthlyForecast extends Component {
  state = {
    monthly_forecast: {},
    franchiseList: [],
    selected_date: new moment(),
    filter: {
      field_office__uuid: '',
      created_at__month: '',
      created_at__year: ''
    },
    franchise_name: '',
    office__uuid: '',
    franchise_list_loader: false,
    report_data_loader: false,
    completed_days: 0,
    remind_days: 0,
    user_role: ""
  }

  componentDidMount = () => {
    let { filter } = this.state;
    const user = JSON.parse(localStorage.getItem('authUser')).user;
    const role = user.role[0];
    const franchise = role === "franchise_owner" ? user.associated_field_offices[0] : "";
    const franchise_name = franchise === "" ||franchise.name === "" ? "All" : franchise.name;
    if(role === "franchise_owner"){
      filter = Object.assign(filter, {
        created_at__month: moment().format('MM'),
        created_at__year: moment().format('YYYY'),
        field_office__uuid: franchise.uuid
      });
    }
    else{
      filter = Object.assign(filter, {
        created_at__month: moment().format('MM'),
        created_at__year: moment().format('YYYY')
      });
    }
    this.props.getMonthlyForecast({...filter});
    this.props.getFranchiseList({ offset: 0 });

    const daysInMonth = moment().daysInMonth();
    const completedDays = moment().format('DD');
    const remindDays = parseInt(daysInMonth) - parseInt(completedDays);
    
    this.setState({
      filter,
      user_role: role,
      franchise_name: franchise_name,
      completed_days: completedDays,
      remind_days: remindDays,
      franchise_list_loader: true,
      report_data_loader: true,
      franchise_name: "All"
    });
  }

  componentDidUpdate = (prevProps, prevState) => {
    
    const selectedDate = this.state.selected_date;
    const daysInMonth = moment(selectedDate).daysInMonth();
  
    if(this.state.selected_date && prevState.selected_date 
        && !moment(this.state.selected_date).isSame(prevState.selected_date, "day"))
    {

      if(new moment().isBefore(selectedDate, 'day'))
      {
        this.setState({completed_days:0,remind_days :daysInMonth})
      }
      else if(new moment().isAfter(selectedDate, 'day'))
      {
        this.setState({completed_days : daysInMonth,remind_days :0})
      }
      else
      {
        const completedDays = moment(selectedDate).format('DD');
        const remindDays = parseInt(daysInMonth) - parseInt(completedDays);
        this.setState({completed_days : parseInt(completedDays),remind_days :remindDays})
      }
    }
  }

  UNSAFE_componentWillUpdate = (props) => {

    const { date } = this.props;
    //Get Customer List
    if (Object.keys(props.MonthlyForecast.data).length > 0 && props.MonthlyForecast.data !== this.props.MonthlyForecast.data) {
      const { period } = props.MonthlyForecast.data.results;
      this.setState({
        monthly_forecast: props.MonthlyForecast.data.results,
        ...(date ? {selected_date: date } : null ),
        report_data_loader: false
      })
      // console.log("props.MonthlyForecast.data::::>", props.MonthlyForecast.data.results)
    }

    if (Object.keys(props.MonthlyForecast.errors).length > 0 && props.MonthlyForecast.errors !== this.props.MonthlyForecast.errors) {
      // message.error('Something went wrong', 10);
      this.setState({
        monthly_forecast: {},
        report_data_loader: false,
      })
    }
    //get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
        franchise_list_loader: false
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      errorHandle(props.FranchiseList.errors)
      this.setState({franchise_list_loader: false})
    }    
  }

  render() {
    let { franchiseList, 
      franchise_name, 
      selected_date, 
      monthly_forecast, 
      filter, 
      franchise_list_loader, 
      report_data_loader,
      completed_days, 
      remind_days,
      office__uuid
    } = this.state;
    return (
      <div className="block-row">
        <ul className="breadcrumb">
          <li onClick={() => { this.props.ChangeComponent(0) }}>
            <span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span>
          </li>
        </ul>
        <div className="filter_wrapper p-0">
          <div className="left_side">
            <h2 className="m-0">Monthly Forecast</h2>
          </div>
          <div className="right_side">
            <div className="form-group flex ai-center fltr-txt">
              <div className="fitem">
                <DatePicker
                  format="MMM YYYY"
                  // defaultValue={new moment()}
                  value={selected_date}
                  // value={selected_date ? moment(selected_date) : null}
                  defaultValue={selected_date}
                  picker="month"
                  allowClear={false}
                  onChange={(e) => {
                    this.setState({
                      selected_date: e,
                      report_data_loader: true,
                      filter: {
                        field_office__uuid: filter.field_office__uuid,
                        created_at__month: moment(e).format('MM'),
                        created_at__year: moment(e).format('YYYY')
                      }
                    })
                    this.props.getMonthlyForecast({ field_office__uuid: filter.field_office__uuid, created_at__month: moment(e).format('MM'), created_at__year: moment(e).format('YYYY') });
                  }}
                  className="form-control" />
              </div>
              <div className="fitem">
                {
                  this.state.user_role === "franchise_owner" ? null :
                    <Select
                      className="swhite franchise_filter"
                      showSearch
                      showArrow={true}
                      suffixIcon={<i className="las la-angle-down"></i>}
                      defaultValue=""
                      onSearch={(e) => { this.props.getFranchiseList({ search: e }) }}
                      disabled={this.props?.is_disable_franchise ? true : false}
                      onBlur={() => { this.props.getFranchiseList({ offset: 0 }) }}
                      onChange={(e, s) => {
                        let { filter } = this.state;
                        filter = Object.assign(filter, { field_office__uuid: s.key });
                        const franchise_name = e===""?"All":e;

                        this.setState({
                          filter,
                          office__uuid: s,
                          report_data_loader: true,
                          franchise_name: franchise_name,
                          filter: {
                            field_office__uuid: s.key,
                            created_at__month: filter.created_at__month,
                            created_at__year: filter.created_at__year
                          }
                        }, () => {
                          this.props.getMonthlyForecast({ field_office__uuid: s.key, created_at__month: filter.created_at__month, created_at__year: filter.created_at__year }); 
                        })
                      }}
                    >
                      <Option value="">All</Option>
                      {map(franchiseList, (item) => {
                        return (
                          <Option key={item.uuid} value={item.name}>{item.name}</Option>
                        )
                      })}
                    </Select>
                }
              </div>
              <div className='fitem'>
                <span className='btn btn-warning btn-small' 
                  onClick={() => { this.props.getMonthForecastCSV(
                    { 
                      'format': 'csv', 
                      field_office__uuid: office__uuid.key,
                      created_at__year: filter.created_at__year,
                      created_at__month: filter.created_at__month, 
                    })
                  }}
                >Export</span>
              </div>
            </div>
          </div>
        </div>
        <div className="frtable">
          {/* header */}
          <div className="frtop">
            <div className="frleft">
              <p>Franchise:  {franchise_name}  <br /> for period {moment(selected_date).format('MMM')} {moment(selected_date).format('YYYY')}</p>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1"> <h6>{`Completed (${completed_days} days)`}</h6> </div>
                <div className="flex-1"> <h6>{`Scheduled work (${remind_days} days left)`}</h6> </div>
              </div>
            </div>
          </div>
          {/* Heading */}
          <div className="frhead">
            <div className="frleft">
              <h4>Product Sales</h4>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1"> <h4>{monthly_forecast?.products?.product_total_complete ? `$ ${formatToCurrency(monthly_forecast?.products?.product_total_complete)}` : '-'}</h4> </div>
                <div className="flex-1"> <h4>{monthly_forecast?.products?.product_total_forecast ? `$ ${formatToCurrency(monthly_forecast?.products?.product_total_forecast)}` : '-'}</h4> </div>
              </div>
            </div>
          </div>
          {/* Body */}
          <div className="frbody">
            <div className="frleft">
              <ul>
                {map(monthly_forecast?.products?.products, (item, i) => {
                  return (
                    <li key={i}>{item.name}</li>
                  )
                })}
              </ul>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1">
                  <ul>
                    {map(monthly_forecast?.products?.products, (item, i) => {
                      return (
                        <li key={i}>{item?.completed_price ? `$ ${formatToCurrency(item?.completed_price)}` : '-'}</li>
                      )
                    })}
                  </ul>
                </div>
                <div className="flex-1">
                  <ul>
                    {map(monthly_forecast?.products?.products, (item, i) => {
                      return (
                        <li key={i}>{item?.forecast_price ? `$ ${formatToCurrency(item?.forecast_price)}` : '-'}</li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Heading */}
          <div className="frhead">
            <div className="frleft">
              <h4>Services</h4>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1"> <h4>{monthly_forecast?.services?.completed_total_services ? `$ ${formatToCurrency(monthly_forecast?.services?.completed_total_services)}` : '-'}</h4> </div>
                <div className="flex-1"> <h4>{monthly_forecast?.services?.forecast_total_services ? `$ ${formatToCurrency(monthly_forecast?.services?.forecast_total_services)}` : '-'}</h4> </div>
              </div>
            </div>
          </div>
          {/* Body */}
          <div className="frbody">
            <div className="frleft">
              <div className="flex-1">
                <p>Residential Services</p>
                <ul>
                  {map(monthly_forecast?.services?.residential_services, (item, i) => {
                    return (
                      <li key={i}>{item?.name ? item?.name : '-'}</li>
                    )
                  })}
                </ul>
                <p> Commercial Services</p>
                <ul>
                  {map(monthly_forecast?.services?.commercial_services, (item, i) => {
                    return (
                      <li key={i}>{item?.name ? item?.name : '-'}</li>
                    )
                  })}
                </ul>
              </div>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1">
                  {/* Residenatial */}
                  <ul style={{"marginTop": "28px"}}>
                    {map(monthly_forecast?.services?.residential_services, (item, i) => {
                      return (
                        <li key={i}>{item?.completed_price ? `$${formatToCurrency(item?.completed_price)}` : '-'}</li>
                      )
                    })}
                  </ul>

                  {/* Commercial */}
                  <ul style={{"marginTop": "28px"}}>
                    {map(monthly_forecast?.services?.commercial_services, (item, i) => {
                      return (
                        <li key={i}>{item?.completed_price ? `$${formatToCurrency(item?.completed_price)}` : '-'}</li>
                      )
                    })}
                  </ul>
                </div>
                <div className="flex-1">
                  {/* Residenatial */}
                  <ul style={{"marginTop": "28px"}}>
                    {map(monthly_forecast?.services?.residential_services, (item, i) => {
                      return (
                        <li key={i}>{item?.forecast_price ? `$ ${formatToCurrency(item?.forecast_price)}` : '-'}</li>
                      )
                    })}
                  </ul>

                  {/* Commercial */}
                  <ul style={{"marginTop": "28px"}}>
                    {map(monthly_forecast?.services?.commercial_services, (item, i) => {
                      return (
                        <li key={i}>{item?.forecast_price ? `$ ${formatToCurrency(item?.forecast_price)}` : '-'}</li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Heading */}
          <div className="frhead">
            <div className="frleft">
              <h4>Discounts</h4>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1"> <h4>{monthly_forecast?.discounts?.completed_total_discounts ? `$ ${formatToCurrency(monthly_forecast?.discounts?.completed_total_discounts)}` : '-'}</h4> </div>
                <div className="flex-1"> <h4>{monthly_forecast?.discounts?.forecast_total_discounts ? `$ ${formatToCurrency(monthly_forecast?.discounts?.forecast_total_discounts)}` : '-'}</h4> </div>
              </div>
            </div>
          </div>
          {/* Body */}
          <div className="frbody">  
            <div className="frleft">
              <ul>
                {map(monthly_forecast?.discounts?.discounts, (item, i) => {
                  return (
                    <li key={i}>{item?.name ? item?.name : '-'}</li>
                  )
                })}
              </ul>
            </div>
            <div className="frright">
              <div className='flex'>
                <div className='flex-1'>
                  <ul>
                    {map(monthly_forecast?.discounts?.discounts, (item, i) => {
                      return (
                        <li key={i}>{item?.completed_price ? `$${formatToCurrency(item?.completed_price)}` : '-'}</li>
                      )
                    })}
                  </ul>
                </div>
                <div className='flex-1'>
                  <ul>
                    {map(monthly_forecast?.discounts?.discounts, (item, i) => {
                      return (
                        <li key={i}>{item?.forecast_price ? `$ ${formatToCurrency(item?.forecast_price)}` : '-'}</li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="frfoot">
            <div className="frleft">
              <h4>Sub-total</h4>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1">
                  <h4>$ {monthly_forecast?.billed_complete_total ? formatToCurrency(monthly_forecast?.billed_complete_total) : '0.00'}</h4>
                </div>
                <div className="flex-1">
                  <h4>$ {monthly_forecast?.billed_forecast_total ? formatToCurrency(monthly_forecast?.billed_forecast_total) : '0.00'}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="frtable p-0 m-0">
          <div className="frfoot">
            <div className="frleft">
              <h4>Total Complete/Forecast for the period</h4>
            </div>
            <div className="frright">
              <div className="flex">
                <div className="flex-1">

                </div>
                <div className="flex-1">
                  <h4>${monthly_forecast?.total ? formatToCurrency(monthly_forecast?.total) : '0.00'}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {(franchise_list_loader || report_data_loader) ? <Loader /> : ''}
      </div>
    );
  }
}

export default MonthlyForecast;